import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

import activityAndMovementHeroGradients from '../_data/activityAndMovementHeroGradients';

const ActivityAndMovementHero = (): JSX.Element => {
  //TODO: GROW-1607 clean up Gen3 clean up
  const OR4Enabled = useOuraGen4Enabled();
  return (
    <section data-cy="activity-and-movement-hero">
      <LandingPageHero
        backgroundProps={{
          color: 'cream-100',
          gradients: activityAndMovementHeroGradients,
        }}
        copy="activity_hero_copy"
        eyebrow="activity_hero_eyebrow"
        images={[
          {
            localizedAlt: OR4Enabled ? 'soccer_alt' : 'activity_surfer_img_alt',
            src: OR4Enabled
              ? '/activity/soccer-ball'
              : '/blue-sky/activity-and-movement/hero-two-update',
          },
          {
            localizedAlt: OR4Enabled
              ? 'skate_boarding_alt'
              : 'activity_bike_img_alt',
            src: OR4Enabled
              ? '/activity/skate-boarding'
              : '/blue-sky/activity-and-movement/hero-one-update',
          },
        ]}
        textColor="text-brown-600"
        title="activity_hero_title"
      />
    </section>
  );
};

export default ActivityAndMovementHero;
